actual object AppReview {
    actual fun requestReview() = Unit
}
